module.exports = __webpack_public_path__ + "static/media/email.15258200.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/email.svg
// module id = 82
// module chunks = 0